import React from "react";

function SortingIcon() {
  return (
    <span className="anticon anticon-sort">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 18 12"
      >
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M0 12h6v-2H0v2zM0 0v2h18V0H0zm0 7h12V5H0v2z"
        ></path>
      </svg>
    </span>
  );
}

export default SortingIcon;
